import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostBinding, Inject, NgZone, OnInit, QueryList, signal, ViewChild, ViewChildren, DOCUMENT } from '@angular/core';
import { AlertPopup, config, HttpLoader } from 'app/app.config';
import { AssistBotService } from 'app/components/ai-assist/assist-bot.service';
import { ChatBotComponent } from './chat-bot/chat-bot.component';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { AskQuestionService } from './ask-question.service';
import { ConfirmationService, MenuItem } from 'primeng/api';

import * as _ from 'underscore';

declare const $: any;
declare const annyang: any;
declare var webkitSpeechRecognition: any;

interface SpeechRecognition extends EventTarget {
  lang: string;
  continuous: boolean;
  interimResults: boolean;
  start(): void;
  end(): void;
  onresult: ((event: SpeechRecognitionEvent) => void) | null;
  onError: ((event: any) => void) | null;
  onEnd: (() => void) | null;

}

interface SpeechRecognitionEvent extends Event {
  resultIndex: number;
  result: SpeechRecognitionResult;
}

@Component({
  selector: 'app-ask-questions',
  // imports: [],
  templateUrl: './ask-questions.component.html',
  styleUrl: './ask-questions.component.scss'
})
export class AskQuestionsComponent implements OnInit {

  @HostBinding('class.flex-grid') leftBarClass = true;
  @HostBinding('style.width') flexwidth = '100%';
  @ViewChild('chatwrapper') private chatWrapper: ElementRef;
  @ViewChild('autoCompleteInput') inputField!: ElementRef;
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;
  @ViewChild('chatArea') private myScrollContainer: ElementRef;
  @ViewChild('chatContainer') private chatContainer!: ElementRef;
  @ViewChildren('aiComponent') aiComponents!: QueryList<ChatBotComponent>;


  messages: { type: 'user' | 'bot', text: string[] }[] = [];
  private scrollbarHeight: boolean = true;
  menuItem: MenuItem[] = [];
  private isAtBottom = true;
  isSidebarCollapsed = false;

  activeVoiceOver: boolean = false;
  queryInputValue = "";
  isRecording: boolean = false;
  autoSearchDafaultValue: string = "";
  voiceActiveSectionDisabled: boolean = false;
  voiceActiveSectionError: boolean = false;
  voiceActiveSectionSuccess: boolean = false;
  voiceActiveSectionListening: boolean = false;
  voiceText: any;
  viewBotHistoryList: boolean = false;
  showSearchSec: boolean = true;
  showPaginateSpinner = false;
  search: string="";
  sortBy = 'time';
  listSortBy = 'updatedAt';
  is_tour_completed = false;
  totalRowCount: number = 0;
  activeUrl: any;

  recognition!: SpeechRecognition;
  searchInList = new Subject<any>();
  isLoggedUserId: any;
  isSidebarOpen = false;
  chatData: any[] = [];
  isBotTitle: string = "";
  private headingSubscription!: Subscription;
  isExpanded = false;

  RECORD_LIMIT: number = config.DEFAULT_RECORD_LIMIT;
  OFFSET: number = config.DEFAULT_OFFSET;

  // private BotURL = AI_BOT_CONFIG.agent.llmUrl;

  historyRecord: any[] = [];
  private shouldScroll = false;
  modalScrollThrottle = config.SCROLL_THROTTLE;
  modelScrollDistance = config.DEFAULT_SCROLL_DIST;
  viewControl = {
    changedSearchText: false
  };

  selectedItem: any = null;
  isMobileSidebarOpen = false;


  constructor(
    private assistBotService: AssistBotService,
    private botService: AskQuestionService,
    private ngZone: NgZone,
    private httpLoader: HttpLoader,
    private alert: AlertPopup,
    private route: ActivatedRoute,
    private chatRef: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.searchInList.pipe(
      debounceTime(500)
    ).subscribe((event: any) => {
      this.search = event.target.value;

      if (!this.search) {
        return;
      }
      this.viewControl.changedSearchText = true;
      this.getBotHistory(0)
    })
  }

  ngOnInit() {

    try {
      this.botService.historyList = [];

      this.getBotHistory(0);

    } catch (error) {
      console.log(error);

    }

    const payload = {
      session_id: localStorage.getItem('session_id')
    };

    // this.botService.llmModelHistory(payload).subscribe((result:any) => {
    //   this.historyRecord = result.history;

    //   console.log(this.historyRecord);

    // })
  }

  onScroll() {
    const container = this.chatContainer.nativeElement;
    const threshold = 50; // pixels from bottom to consider "at bottom"
    const position = container.scrollHeight - container.scrollTop - container.clientHeight;
    this.isAtBottom = position < threshold;
  }

  ngAfterViewChecked() {
    if (this.isAtBottom) {
      this.scrollToBottom();
    }
  }

  openMenu(item: any) {
    this.menuItem = [
      { label: 'View', icon: 'pi pi-eye' },
      { label: 'Edit', icon: 'pi pi-pencil' },
      { label: 'Delete', icon: 'pi pi-trash' }
    ];
  }

  loadMoreMessages() {

  }

  getBotHistory(pageNo: number) {
    try {
      if (pageNo === 0) {
        this.OFFSET = 0;
        this.httpLoader.showLoader();
      }

      this.listSortBy = this.sortBy === 'time' ? 'updatedAt' : 'question';

      const offset = this.OFFSET;
      const payload = {
        offset: offset,
        limit: this.RECORD_LIMIT,
        search: this.search || '',
        sort: this.sortBy,
        userId: localStorage.getItem('user_id'),
      };

      this.botService.getAIHistoryData(payload).subscribe({
        next: (result: any) => {
          const records = result.data || [];

          if (offset === 0) {
            this.httpLoader.hideLoader();

            // Reset & assign on first page
            this.historyRecord = [...records];
            this.chatData = [...records];
          } else {
            this.showPaginateSpinner = false;

            // Append on load-more
            this.historyRecord = [...this.historyRecord, ...records];
            this.chatData = [...this.chatData, ...records];
          }

          this.totalRowCount = result.totalRowCount;
          this.selectedItem = this.historyRecord;
        },

        error: (err) => {
          this.alert.showAlertMessage(err.error);
          this.showPaginateSpinner = false;
          this.httpLoader.hideLoader();
        }
      });

    } catch (error) {
      this.httpLoader.hideLoader();
    }
  }


  showSearchbox(toggle: any) {
    this.showSearchSec = !this.showSearchSec;

    if (this.viewControl.changedSearchText) {
      try {
        this.search = '';
        const offset = 0;
        this.viewControl.changedSearchText = false;
        this.getBotHistory(offset);
      } catch (error) {
        this.httpLoader.hideLoader();
      }
    }
  }

  toggleSidebar() {
    // this.isSidebarCollapsed = !this.isSidebarCollapsed;
    this.viewBotHistoryList = !this.viewBotHistoryList;
  }

  openMobileSidebar() {
    this.isMobileSidebarOpen = true;
  }

  closeMobileSidebar() {
    this.isMobileSidebarOpen = false;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  openSidebar() {
    this.isSidebarOpen = true;
  }

  toggleHistoryList() {
    this.isExpanded = !this.isExpanded;
  }

  onClickHomePage() {
    this.botService.stopListening();
    this.botService.stopSpeaking();
  }

  onKeyPressEvent(event: KeyboardEvent) {

    if (event.key === 'Enter') {
      this.submitQuestion();
    }
  }

  trackByFn(index: number, item: any) {
    return item.sequence_id || index;
  }

  onScrollUp(event: any) {
    const listLength = this.chatData.length;
    if ((this.totalRowCount > listLength) && !this.showPaginateSpinner) {
      this.showPaginateSpinner = true;
      this.OFFSET += 1;

      const offset = this.OFFSET;
      const beforeScrollHeight = this.myScrollContainer.nativeElement.scrollHeight;
    }

  }


  onHistoryClick(item: any) {
    this.selectedItem = item;

    setTimeout(() => {
      const child = this.aiComponents.find(c => c.data.sequence_id === item.sequence_id);
      if (child) {
        const container = this.chatContainer.nativeElement;
        const childElement = child.contentDiv.nativeElement;

        // ⚡ scroll in ~150ms (fast)
        // this.scrollTo(container, childElement.offsetTop - container.clientHeight / 2, 150);

        container.scrollTop = childElement.offsetTop - container.clientHeight / 2;

        child.focusContent();
      }
    });
  }

  startVoiceRecognition() {
    if (!annyang) {

      return;
    }

    this.activeVoiceOver = true;
    this.inputField.nativeElement.placeholder = 'Listening...';
    this.inputField.nativeElement.classList.add('listening');

    // Clear old commands
    annyang.removeCommands();

    // Define a generic command (anything spoken gets captured)
    const commands = {
      '*text': (text: string) => {
        this.ngZone.run(() => {
          // Instead of replacing, append to the existing input
          if (this.queryInputValue) {
            this.queryInputValue += ' ' + text;
          } else {
            this.queryInputValue = text;
          }
        });
      }
    };

    annyang.addCommands(commands);

    annyang.addCallback('end', () => {
      this.ngZone.run(() => {
        this.activeVoiceOver = false;
        this.inputField.nativeElement.classList.remove('listening');

        // if (this.queryInputValue && this.queryInputValue.trim() !== '') {
        //   this.submitQuestion();
        // }
      })
    })

    annyang.start({ autoRestart: false, continuous: false });
  }

  stopVoiceRecord() {
    if (annyang) {
      annyang.abort();
      annyang.removeCommands();
    }
    this.activeVoiceOver = false;
    this.inputField.nativeElement.placeholder = 'Ask anything...';
    this.inputField.nativeElement.classList.remove('listening');
    this.queryInputValue = "";
  }

  submitVoiceRecord() {

    this.stopVoiceRecord();
  }

  // submitQuestion() {
  //   let questionIdex = 0;
  //   this.activeVoiceOver = false;
  //   // this.scrollToBottom();
  //   let answerData = [
  //     {
  //       "question_id": "",
  //       "bot_type": "bot",
  //       "question": this.queryInputValue.trim(),
  //       "answer": "",
  //       "source_doc": "",
  //       "search": true
  //     }
  //   ];

  //   //  this.messages.push({type: 'user', text: answerData})

  //   this.stopVoiceRecord();
  //   this.chatData.push(answerData[0]);
  //   this.scrollbarHeight = true;
  //   // this.chatData.sort((b, a) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
  //   // this.chatData = [...this.chatData].sort(
  //   //   (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
  //   // );
  //   this.queryInputValue = "";
  //   // this.aiComponent.startTyping();

  //   // this.scrollToBottom();
  // }

  submitQuestion() {
    this.activeVoiceOver = false;

    const message = {
      question_id: "",
      bot_type: "bot",
      question: this.queryInputValue.trim(),
      answer: "",
      source_doc: "",
      search: true
    };

    if (!message.question) return;

    this.stopVoiceRecord();

    // Better for Angular change detection
    this.chatData = [...this.chatData, message];

    this.scrollbarHeight = true;
    this.queryInputValue = "";

    // this.aiComponent.startTyping();
    // this.scrollToBottom();
  }


  scrollToBottom(smooth: boolean = true) {
    try {
      const container = this.chatContainer.nativeElement;

      // container.scrollTop = container.scrollHeight;
      container.scrollTo({
        top: container.scrollHeight,
        behavior: smooth ? 'smooth' : 'auto'
      });
    } catch (err) {
      // console.error('Scroll error', err);
    }
  }

  onScrollDown() {
    const listOfHistoryLength = this.historyRecord.length;
    if (this.totalRowCount > listOfHistoryLength && !this.showPaginateSpinner) {
      this.OFFSET += 1;
      this.showPaginateSpinner = true;
      this.getBotHistory(this.OFFSET);
    }
  }
  onBotHistoryCreated(anwser: any) {
    this.historyRecord.push(anwser);
  }

  deleteHistory(history: any) {
    // try {
    //   this._confirmation.openConfirmDialog('', {
    //     title: 'Confirmation',
    //     message: `Are you sure you want to delete the history?`,
    //     btnOkText: 'YES',
    //     btnCancelText: 'NO',
    //     onClose: (data: any) => {
    //       if (data) {
    //         this.httpLoader.showLoader();
    //         const id = history.history_id;

    //         const index = _.findIndex(this.historyRecord, { history_id: id });

    //         this.botService.deleteAIHistory(id).subscribe((response: any) => {
    //           this.httpLoader.hideLoader();
    //           this.historyRecord.splice(index, 1);
    //           this.getBotHistory(0);
    //           this.alert.showAlertMessage(response);
    //         }, (err: any) => {
    //           this.httpLoader.hideLoader();
    //           this.alert.showAlertMessage(err.error);
    //         })
    //       } else {
    //         return true;
    //       }
    //     }
    //   })
    // } catch (error) {
    //   console.log(error);
    //   this.httpLoader.hideLoader();
    // }
  }

  isSidebarHistoryOpen() {
    this.viewBotHistoryList = !this.viewBotHistoryList;
  }

  ngOnDestroy() {
    if (this.headingSubscription) {
      this.headingSubscription.unsubscribe();
    }
  }

}
